import Service from "../../Service";

const resource = "genobjectalias/";

export default {
  tables(search, requestID) {
    return Service.post(resource + "tables", {}, {
      params: { search: search || "", requestID },
    });
  },
  columns(table, search, requestID) {
    return Service.post(resource + "columns", {}, {
      params: { table, search: search || "", requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(parameters, requestID) {
    console.log("AliasService.save", parameters);
    
    return Service.post(resource + "save", parameters, {
      params: { requestID },
    });
  },
  get(alsID, requestID) {
    return Service.post(resource + "get", {}, {
      params: { alsID, requestID },
    });
  },
};
